import { render, staticRenderFns } from "./CriterionItem.vue?vue&type=template&id=316339dc&lang=pug"
import script from "./CriterionItem.vue?vue&type=script&lang=js"
export * from "./CriterionItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports